import React, { useEffect, useState } from 'react'
import { getLocalStorage, handleDownloadImage, handleToggleScreen } from '../helpers/jsHelper';
import ImagePreviewSlider from '../common/ImagePreviewSlider';
import { Download, FooterButton } from '../common';
import { DOWNLOAD_ICON } from '../constants/assetConstants';
import { FullScreenIcon, MagicToolIcon } from '../assets/icons';
import { useUserContext } from '../contexts/UserContext';
import { AI_WEBSITE_URL } from '../constants/routePathConstants';
import { useImagineAIActions } from '../hooks/useImagineAIActions';
import BinIcon from '../components/icons/BinIcon';
import ShareIcon from '../components/icons/ShareIcon';
import { PASS } from '../constants/renderPreviewConstants';
import { getImageTypeFooterComponent } from './NewProductUI/ProductDetails';
function ImagineAIDetails({ setIsOpen, data, hasMore, fetchMoreData, list, loading }) {
    if (!data) return null
    const [photoIndex, setPhotoIndex] = useState(list.findIndex(item => item.id === data.id));
    const [imageList, setImageList] = useState(list);
    const [currentImage, setCurrentImage] = useState(data);
    const { currentUser } = useUserContext();
    const [pass, setPass] = useState({[data?.id] : {current: PASS.FILMIC}})

    const {
        onDelete: _onDelete,
        downloadImagineAI,
    } = useImagineAIActions({
        item: currentImage,
    });

    const handlePassChange = () => {

    }

    const handleMagicToolClick = () => {
        if (currentImage?.output_image) {
            const token = getLocalStorage('token');
            const refreshToken = getLocalStorage('refresh_token');
            const url = `${AI_WEBSITE_URL}magic-tool?renderFile=${encodeURIComponent(currentImage?.output_image)}&token=${encodeURIComponent(token)}&refresh_token=${encodeURIComponent(refreshToken)}`
            window.open(url, "_blank");
        }
    }

    const handleReUse = () => {
      if (currentImage?.id) {
        const token = getLocalStorage('token');
        const refreshToken = getLocalStorage('refresh_token');
        const url = `${AI_WEBSITE_URL}image-gen?ai_id=${
          currentImage?.id
        }&token=${encodeURIComponent(token)}&refresh_token=${encodeURIComponent(refreshToken)}`;
        window.open(url, '_blank');
      }
    };

    const footerActions = [
        {
            element: Download,
            title: 'Download',
            footerButton: true,
            iconSrc: DOWNLOAD_ICON,
            clickFunction: () => {
                downloadImagineAI({ id: currentImage?.id, url: pass?.[currentImage?.id]?.current === PASS.STANDARD ? currentImage?.render_image_details?.file : currentImage?.render_image_details?.filmic_file, name: currentImage?.name })
            },
            seq: 1,
            permissionsRequired: false,
            isVisible: true
        },
        // {
        //     element: FooterButton,
        //     title: 'Magic tool',
        //     footerButton: currentUser,
        //     icon: MagicToolIcon,
        //     clickFunction: () => {
        //         handleMagicToolClick()
        //     },
        //     seq: 2,
        //     permissionsRequired: false,
        //     isVisible: true
        // },
        {
            element: FooterButton,
            title: 'Re-Imagine',
            footerButton: false, // true, // hiding re-imagine tool
            icon: ShareIcon,
            clickFunction: () => {
                handleReUse()
            },
            seq: 3,
            permissionsRequired: false,
            isVisible: !currentImage?.upscaled && currentImage?.tool_type !== "magic_tool"
        },
        {
            element: FooterButton,
            title: 'Full screen',
            footerButton: true,
            icon: FullScreenIcon,
            clickFunction: () => {
                handleToggleScreen();
            },
            seq: 4,
            permissionsRequired: false,
            isVisible: true
        },
        {
            element: FooterButton,
            title: 'Delete',
            footerButton: currentUser,
            icon: BinIcon,
            clickFunction: () => _onDelete(currentImage?.id),
            seq: 4,
            permissionsRequired: true,
            isVisible: true
        },
    ];
    const handleFooter = () => {
        return (
            <>
                {currentImage?.standard_output_image && getImageTypeFooterComponent(pass, setPass, [currentImage], 0, {marginRight : "1rem"})}
                <footer className={'footer-style preview-display-footer'}>
                    <h1 className="title px-0">{currentImage?.name || ''}</h1>
                    {footerActions.length > 0 && (
                        <ul className="footer-action-list ced-action">
                            {footerActions
                                ?.filter(
                                    ({ permissionsRequired, isVisible }) =>
                                        !permissionsRequired && isVisible
                                )
                                ?.map((a, index) => {
                                    const { element, ...rest } = a;
                                    const Component = element;
                                    return (
                                        <Component
                                            // shareId={id}
                                            id={`action${index}}`}
                                            key={`action${index}}`}
                                            {...rest}
                                        />
                                    );
                                })}
                        </ul>
                    )}
                </footer>
            </>
        );
    };

    useEffect(() => {
        const _images = list.map((_item, _index) => ({ ..._item, index: _index, render_image_details: {filmic_file: _item?.output_image || _item?.input_image || _item?.manual_output_image_path,  file: _item?.output_image || _item?.input_image || _item?.manual_output_image_path}}))
        setImageList(_images)
        setCurrentImage(_images?.[photoIndex])

        const _pass = {}

        _images?.forEach(_item => {
            _pass[_item.id] = {current: PASS.FILMIC}
        })
        setPass(_pass)
    }, [list])

    useEffect(() => {
        if (currentImage?.render_image_details) setCurrentImage(imageList?.[photoIndex])

        if (!pass?.[imageList?.[photoIndex]?.id]){
            setPass({...pass, [imageList?.[photoIndex]?.id] : {current: PASS.FILMIC}})
        }

        if (photoIndex >= (imageList?.length - 5) && hasMore && !loading) fetchMoreData()
    }, [photoIndex])

    return (
        <>
            <ImagePreviewSlider
                // title={currentImage?.name || ''}
                imagesList={imageList}
                {...{ pass, setPass, setIsOpen, photoIndex, setPhotoIndex, handleToggleScreen }}
                footer={handleFooter()}
                infiniteLoop={false}
            />
        </>
    )
}

export default ImagineAIDetails